import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=4ce508d2"
import script from "./Template.vue?vue&type=script&lang=js"
export * from "./Template.vue?vue&type=script&lang=js"
import style0 from "./Template.vue?vue&type=style&index=0&id=4ce508d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports